import { createElement, useRef } from 'react';
import { uuid } from '../../../../utils';
const Svg = ({ color, width = 460, height = 36 }) => {
    const { linearGradient1 } = useRef({
        linearGradient1: `tb1linearGradient1${uuid()}`,
    }).current;
    return (createElement("svg", { width: `${width}px`, height: `${height}px` },
        createElement("defs", null,
            createElement("linearGradient", { x1: "100%", y1: "50%", x2: "3.85108612e-14%", y2: "50%", id: `${linearGradient1}` },
                createElement("stop", { stopColor: color, stopOpacity: "0", offset: "0%" }),
                createElement("stop", { stopColor: color, offset: "100%" }))),
        createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            createElement("g", { transform: "translate(-40.000000, -1683.000000)" },
                createElement("g", { transform: "translate(40.000000, 1683.000000)" },
                    createElement("g", { transform: `translate(0.000000, ${height / 2 - 6})`, fill: color, fillRule: "nonzero" },
                        createElement("circle", { opacity: "0.3", cx: "6", cy: "6", r: "6" }),
                        createElement("circle", { cx: "6", cy: "6", r: "4" })),
                    createElement("g", { transform: `translate(2.000000, ${height - 2})` },
                        createElement("rect", { fill: color, fillRule: "nonzero", x: "0", y: "0", width: "10", height: "2" }),
                        createElement("rect", { fill: color, fillRule: "nonzero", opacity: "0.8", x: "14", y: "0", width: "8", height: "2" }),
                        createElement("rect", { fill: color, fillRule: "nonzero", opacity: "0.6", x: "26", y: "0", width: "6", height: "2" }),
                        createElement("rect", { fill: color, fillRule: "nonzero", opacity: "0.4", x: "36", y: "0", width: "4", height: "2" }),
                        createElement("rect", { fill: `url(#${linearGradient1})`, opacity: "0.4", x: "44", y: "0", width: "100%", height: "2" })))))));
};
export default Svg;
